export const defaultError = 'There was an error with your request'
export const default422Error = 'There was an error processing your form'
